import { render, staticRenderFns } from "./Responsibilities.vue?vue&type=template&id=292c026a"
import script from "./Responsibilities.vue?vue&type=script&lang=js"
export * from "./Responsibilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports